<script setup lang="ts">
import { computed } from "vue";
import { isSelfAdmin } from "../../../../states/adminsState";
import {
  ChangeRecord,
  loadingRecordState,
  recordState,
} from "../../../../states/recordState";
import { locale } from "../../../../locale";
import RecordIcon20x20 from "../../../icons/popovers/RecordIcon20x20.vue";
import BasePopoverItem from "./BasePopoverItem.vue";

const props = defineProps<{
  close: () => void;
}>();

const recordAction = () => {
  if (isSelfAdmin.value && !loadingRecordState.value) {
    ChangeRecord();
  }
  props.close();
};

const text = computed(() => {
  return !isSelfAdmin.value && recordState.recording
    ? locale.roomrecords
    : recordState.recording
      ? locale.endrecord
      : loadingRecordState.value
        ? locale.uwaitrecord
        : locale.startrecord;
});
</script>
<template>
  <BasePopoverItem :text="text" :inactive="loadingRecordState" @click.stop="recordAction">
    <RecordIcon20x20 />
  </BasePopoverItem>
</template>
<style scoped></style>
